import { computed } from "mobx";
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from "react-router-dom";
import { useLeadStore } from '../..';
import useCircleWithRadiusOnMap from "../../hooks/useCircleWithRadiusOnMap";
import useNearestLocations from "../../hooks/useNearestLocations";
import useRadiusCompanyIdsOnMap from "../../hooks/useRadiusCompanyIdsOnMap";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { distinctBy } from "../../utils/utils";
import RadiusDropdown from "../RadiusDropdown";
import NearestLocationsGrid from "../locations/NearestLocationsGrid";

function LeadDetailsCompaniesTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const leadStore = useLeadStore();
    const lead = useMemo(() => computed(() => leadStore.leads.find(l => l.id.toString() === id)!), [id]).get();
    const [radius, setRadius] = useState(5);
    const nearestLocations = useNearestLocations(lead.centerPoint, radius);
    useCircleWithRadiusOnMap(lead.centerPoint, radius, visible, "LeadDetailsCompaniesTab");
    useRadiusCompanyIdsOnMap(nearestLocations, visible);

    useEffect(() => setEntityCount(distinctBy(nearestLocations, l => l.pipedriveCompanyId).length), [nearestLocations, setEntityCount]);

    if (!visible)
        return null;

    return (
        <NearestLocationsGrid
            locations={nearestLocations}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(LeadDetailsCompaniesTab);
